var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 57,
    viewBox: "0 0 49 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.078 20.3953C43.078 10.8021 33.9688 2.9826 23.7309 4.11119C13.4744 5.24184 -0.306825 20.5983 16.9334 37.9688C17.3324 38.3708 17.7481 38.774 18.1807 39.178C19.9519 40.8319 22.0087 42.5014 24.3806 44.176C24.799 44.4715 25.2274 44.7672 25.6656 45.0629C29.9785 41.395 34.3316 38.3518 37.6065 34.6637C40.8814 30.9756 43.078 26.6427 43.078 20.3953Z",
    fill: "url(#paint0_linear_66_129)",
    stroke: "#4B4679"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8433 20.755C40.8433 12.4666 32.9731 5.71062 24.1277 6.68571C15.2661 7.66258 3.35931 20.9304 18.2547 35.9383C18.5994 36.2857 18.9585 36.634 19.3324 36.9831C20.8626 38.412 22.6397 39.8544 24.6889 41.3013C25.0505 41.5566 25.4206 41.812 25.7992 42.0676C29.5255 38.8985 33.2866 36.2692 36.116 33.0827C38.9455 29.8963 40.8433 26.1527 40.8433 20.755Z",
    fill: "#4B4679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53418 51.2965L17.0992 43.5576C17.4982 43.9597 17.9139 44.3628 18.3466 44.7668C20.1177 46.4208 22.1745 48.0902 24.5464 49.7649C24.9649 50.0603 25.3932 50.356 25.8314 50.6517C30.1443 46.9838 34.4974 43.9406 37.7723 40.2525L48.0002 45.2505L41.8735 56.2139L32.8448 49.7649L21.3977 56.2139L14.465 49.7649L2.53418 51.2965Z",
    fill: "#9486DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.465 49.7649L2.53418 51.2965L17.0992 43.5576C17.4982 43.9597 17.9139 44.3628 18.3466 44.7668M14.465 49.7649L21.3977 56.2139M14.465 49.7649L18.3466 44.7668M21.3977 56.2139L32.8448 49.7649M21.3977 56.2139L24.5464 49.7649M32.8448 49.7649L41.8735 56.2139L48.0002 45.2505L37.7723 40.2525M32.8448 49.7649L37.7723 40.2525M37.7723 40.2525C34.4974 43.9406 30.1443 46.9838 25.8314 50.6517C25.3932 50.356 24.9649 50.0603 24.5464 49.7649M18.3466 44.7668C20.1177 46.4208 22.1745 48.0902 24.5464 49.7649",
    stroke: "#363354"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1274 24.7067L20.7428 31.8706L22.5439 33.4431L29.9285 26.1627C31.4895 24.7261 33.6748 20.9558 29.9285 17.3681C25.2456 12.8834 15.2193 18.7659 21.5833 26.1627L19.7221 27.6771C13.9586 22.7264 18.1527 13.4076 25.7859 13.4076C32.8103 13.4076 34.3712 19.8725 34.3112 21.7945C34.1275 27.6771 27.527 31.2881 24.1649 35.0739M36.7127 20.3967C35.632 13.6988 29.148 11.2526 25.7859 11.2526",
    stroke: "#C0B5F7",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8112 24.7168L26.8573 23.7024L28.4266 22.1542L25.7066 19.5382L23.248 22.1542L25.8112 24.7168Z",
    fill: "#50AC58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53613 15.3246C6.08931 13.1736 6.51474 10.9332 7.71894 9.0958C8.92314 7.25837 10.8076 5.97419 12.9581 5.52548",
    stroke: "#9486DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93262 16.0749C2.28602 12.969 2.90009 9.72976 4.63879 7.07674C6.3775 4.42373 9.10259 2.56793 12.2084 1.92133",
    stroke: "#9486DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_129",
    x1: 25.3194,
    y1: -11.0153,
    x2: 26.3551,
    y2: 56.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6753CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.0975fc7a04061a5d8260bb760ed50a3f.svg";
export { ForwardRef as ReactComponent };